"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const authorization_1 = require("utils/authorization");
const store_1 = require("store");
const grid_1 = __importDefault(require("components/templates/grid"));
const production_statistic_style_1 = __importDefault(require("../production-statistic.style"));
const production_statistic_action_1 = __importDefault(require("../production-statistic.action"));
const button_1 = require("components/atoms/button");
const typography_1 = require("components/atoms/typography");
const svg_1 = require("components/atoms/svg");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const card_1 = require("components/molecules/card");
const production_statistic_column_1 = __importDefault(require("../production-statistic.column"));
const modal_1 = require("components/molecules/modal");
const moment_1 = __importDefault(require("moment"));
const generate_button_passive_color_1 = require("utils/generate-button-passive-color");
const material_1 = require("@mui/material");
const Sync_1 = __importDefault(require("@mui/icons-material/Sync"));
const sync_1 = require("services/sync");
const svg_2 = require("components/atoms/svg");
const ProductionStatistic = () => {
    const { isError, dataGrid, end_date, isLoading, isSuccess, dataStates, start_date, errorMessage, documentExport, isLoadingExport, } = (0, store_1.useAppSelector)(state => state.report.production);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const isExternal = (0, authorization_1.isUserExternal)(userData.contractor_name);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Report', 'Production Data');
    const handleExternalInternalState = (isExternal) => {
        var _a;
        if (isExternal) {
            const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: {
                    logic: 'and',
                    filters: ((_a = dataStates.filter) === null || _a === void 0 ? void 0 : _a.filters.concat({ field: 'contractor_ex_id', operator: 'uuid', value: userData.contractor_id })) ||
                        [{ field: 'contractor_ex_id', operator: 'uuid', value: userData.contractor_id }],
                } });
            return newDataStates;
        }
        else {
            return dataStates;
        }
    };
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading) {
                dispatch(production_statistic_action_1.default.getDataGrid({ dataStates: handleExternalInternalState(isExternal), start_date, end_date }));
            }
            if (documentExport.content) {
                // Noob code ↓↓↓↓ maybe change it if found better way
                const a = document.createElement('a'); //Create <a>
                const filetype = documentExport.filetype === 'pdf'
                    ? 'application/pdf'
                    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                a.href = `data:${filetype};base64,` + documentExport.content; //Image Base64 Goes here
                a.download = documentExport.filename; //File name Here
                a.click(); //Downloaded file
                dispatch(production_statistic_action_1.default.getDataGrid({ dataStates: handleExternalInternalState(isExternal), start_date, end_date }));
                dispatch(production_statistic_action_1.default.clearDocuments());
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized, start_date, end_date, documentExport, isExternal]);
    const handleUserKeyPress = (0, react_1.useCallback)((event) => {
        const { key, keyCode } = event;
        if (keyCode === 13 || key == 'Enter') {
            dispatch(production_statistic_action_1.default.onSetIsLoading({ isLoading: true }));
        }
    }, []);
    (0, react_1.useEffect)(() => {
        window.addEventListener('keydown', handleUserKeyPress);
        return () => {
            window.removeEventListener('keydown', handleUserKeyPress);
        };
    }, [handleUserKeyPress]);
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(production_statistic_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(production_statistic_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        dispatch(production_statistic_action_1.default.onFilterDataStateChange(newDataStates));
    };
    const onSortChange = (e) => {
        if (!isLoading) {
            dispatch(production_statistic_action_1.default.onSortChange(e.sort));
            const newDataStates = Object.assign(Object.assign({}, dataStates), { sort: e.sort });
            dispatch(production_statistic_action_1.default.getDataGrid({ dataStates: newDataStates, start_date, end_date }));
        }
    };
    const [value, setValue] = (0, react_1.useState)({
        start: new Date(start_date),
        end: new Date(end_date),
    });
    const handleChangeDate = (event) => {
        setValue(event.value);
        if (event.value.start && event.value.end) {
            dispatch(production_statistic_action_1.default.onDateChange({
                start_date: (0, moment_1.default)(event.value.start).format('YYYY-MM-DD'),
                end_date: (0, moment_1.default)(event.value.end).format('YYYY-MM-DD'),
            }));
        }
    };
    const [syncState, setSyncState] = (0, react_1.useState)({
        isSync: true, syncMsg: `Last Sync ${(0, moment_1.default)().format('DD MM YYYY HH:mm')}`
    });
    const getLastSync = () => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield (0, sync_1._getLastSync)('report_production');
        if (!data.isError && data.data) {
            const lastSyncBy = data.data.modified_by;
            const lastSync = (0, moment_1.default)(data.data.modified_date).format('DD MM YYYY HH:mm');
            setSyncState({
                isSync: data.data.is_running,
                syncMsg: `Last sync ${lastSync} by ${lastSyncBy}`
            });
        }
    });
    const onClickSync = () => __awaiter(void 0, void 0, void 0, function* () {
        const syncMsg = `Last sync ${(0, moment_1.default)().format('DD MM YYYY HH:mm')} by ${userData.fullname}`;
        setSyncState({ isSync: true, syncMsg });
        yield (0, sync_1._syncMV)('report_production', userData.fullname);
    });
    (0, react_1.useEffect)(() => {
        const interval = setInterval(() => {
            getLastSync();
        }, 2000);
        return () => clearInterval(interval);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { theme: appTheme, valueDate: value, isLoading: isLoading, title: 'Production Data Report', isAdjustment: isAuthorized.view, handleChangeDate: handleChangeDate }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data Saved Successfully', onClose: () => {
                    dispatch(production_statistic_action_1.default.getDataGrid({ dataStates, start_date, end_date }));
                    dispatch(production_statistic_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, style: { 'zIndex': 10 }, errorMessage: errorMessage, onClose: () => dispatch(production_statistic_action_1.default.onCloseError()) }), (0, jsx_runtime_1.jsx)(card_1.Card, Object.assign({ style: production_statistic_style_1.default.cardGridStyle(appTheme) }, { children: (0, jsx_runtime_1.jsxs)(card_1.CardBody, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ style: production_statistic_style_1.default.buttonOuterWrapper }, { children: [(0, jsx_runtime_1.jsx)(typography_1.Typography, Object.assign({ typographyType: 'h6', style: production_statistic_style_1.default.gridTitleFont(appTheme) }, { children: 'Table View' })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: production_statistic_style_1.default.buttonInnerWrapper }, { children: [(0, jsx_runtime_1.jsx)(material_1.Tooltip, Object.assign({ style: { cursor: syncState.isSync ? 'not-allowed' : 'pointer', alignSelf: 'center' }, title: syncState.syncMsg, onClick: () => {
                                                if (!syncState.isSync) {
                                                    onClickSync();
                                                }
                                            } }, { children: (0, jsx_runtime_1.jsx)(Sync_1.default, { color: !syncState.isSync ? undefined : 'disabled' }) })), (0, jsx_runtime_1.jsxs)(button_1.Button, Object.assign({ style: Object.assign(Object.assign({}, production_statistic_style_1.default.button((0, generate_button_passive_color_1.generateBtnModifyColor)(appTheme, false))), { display: 'none' }), onClick: () => {
                                                // dispatch(actions.onClickMutation({ mutationMode: 'upload_history', isLoadingHistory: true }))
                                            } }, { children: [(0, jsx_runtime_1.jsx)(svg_2.HistoryIcon, {}), (0, jsx_runtime_1.jsx)(typography_1.Typography, Object.assign({ typographyType: 'h5', style: production_statistic_style_1.default.buttonFont }, { children: "Sync History" }))] })), (0, jsx_runtime_1.jsxs)(button_1.Button, Object.assign({ disabled: isLoadingExport, isLoading: isLoadingExport, style: production_statistic_style_1.default.button((0, generate_button_passive_color_1.generateBtnModifyColor)(appTheme, isLoadingExport)), onClick: () => {
                                                dispatch(production_statistic_action_1.default.onClickMutation({ mutationMode: false, isLoadingExport: true }));
                                                dispatch(production_statistic_action_1.default.exportDocuments({
                                                    type: 'xlsx',
                                                    end_date: end_date,
                                                    start_date: start_date,
                                                    dataStates: handleExternalInternalState(isExternal)
                                                }));
                                            } }, { children: [(0, jsx_runtime_1.jsx)(svg_1.ExcelIcon, {}), (0, jsx_runtime_1.jsx)(typography_1.Typography, Object.assign({ typographyType: 'h5', style: production_statistic_style_1.default.buttonFont }, { children: "Export To Excel" }))] }))] }))] })), (0, jsx_runtime_1.jsx)(grid_1.default, { pageable: true, sortable: true, cardGrid: false, scrollable: 'scrollable', sort: dataStates.sort, dataStates: dataStates, style: production_statistic_style_1.default.gridHeight, dataGrid: dataGrid, onFilterChange: onFilterChange, onSortChange: onSortChange, columns: production_statistic_column_1.default, onPageChange: v => onDataStateChange('page', v), onTakeChange: v => onDataStateChange('take', v) })] }) }))] }));
};
exports.default = ProductionStatistic;
